// extracted by mini-css-extract-plugin
export default {"promo":"PromoText_promo__Dtg69","innerGrid":"PromoText_innerGrid__WZB2u","gridCol":"PromoText_gridCol__FQkXz"};